export default __webpack_public_path__ + "media/zurb/fonts/ProximaNova-Black-829f67ae96bbe99e1052ad3569f83bbd.otf";